import $ from 'jquery';
import { createPopper } from '@popperjs/core';
import preventOverflow from '@popperjs/core/lib/modifiers/preventOverflow.js';
import { initCustomSelect } from './customSelect.js';
const createDemoPopinController = ({ popinModal, openersList, popperModifiers, controllers }) => {
    const openers = Array.from(openersList);
    if (!popinModal || openers.length === 0) {
        return null;
    }

    const closeBtn = popinModal.querySelector('.close-demo-popin');
    let demoPopinInstance = null;
    let outsideListener = null;

    const removeOutsideListener = () => {
        if (outsideListener) {
            document.removeEventListener('click', outsideListener);
            outsideListener = null;
        }
    };

    const destroyPopper = () => {
        if (demoPopinInstance) {
            demoPopinInstance.destroy();
            demoPopinInstance = null;
        }
    };

    const controller = { popinModal };

    controller.close = () => {
        if (!popinModal.classList.contains('open')) {
            return;
        }
        popinModal.classList.remove('open');
        removeOutsideListener();
        if (window.matchMedia('screen and (min-width: 899px)').matches) {
            openers.forEach((op) => {
                op.style.pointerEvents = 'none';
            });
            setTimeout(() => {
                destroyPopper();
                openers.forEach((op) => {
                    op.style.pointerEvents = 'all';
                });
            }, 600);
        } else {
            destroyPopper();
        }
    };

    controller.open = (opener) => {
        controllers.forEach((c) => {
            if (c !== controller) {
                c.close();
            }
        });
        popinModal.classList.add('open');
        if (window.matchMedia('screen and (min-width: 899px)').matches) {
            destroyPopper();
            demoPopinInstance = createPopper(opener, popinModal, {
                placement: 'auto',
                modifiers: popperModifiers,
            });
            setTimeout(() => {
                outsideListener = (e) => {
                    if (!popinModal.classList.contains('open') || !e.target) {
                        return;
                    }
                    if (popinModal.contains(e.target)) {
                        return;
                    }
                    for (let i = 0; i < openers.length; i += 1) {
                        if (openers[i].contains(e.target)) {
                            return;
                        }
                    }
                    controller.close();
                };
                document.addEventListener('click', outsideListener);
            }, 200);
        }
    };

    if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            controller.close();
        });
    }

    openers.forEach((opener) => {
        opener.addEventListener('click', () => {
            controller.open(opener);
        });
    });

    return controller;
};

const initDemoMenu = () => {
    const popperModifiers = [
        preventOverflow,
        {
            name: 'offset',
            options: {
                offset: [10, 20],
            },
        },
        {
            name: 'flip',
            options: {
                allowedAutoPlacements: ['bottom', 'top'],
            },
        },
        {
            name: 'preventOverflow',
            options: {
                padding: { top: 120, bottom: 20 },
            },
        },
    ];

    const controllers = [];

    document.querySelectorAll('.demo-popin[data-demo-popin]').forEach((popinModal) => {
        const tier = popinModal.getAttribute('data-demo-popin');
        if (!tier) {
            return;
        }
        const tierOpeners = document.querySelectorAll(`.demo-open-btn[data-demo-popin="${tier}"]`);
        const ctrl = createDemoPopinController({
            popinModal,
            openersList: tierOpeners,
            popperModifiers,
            controllers,
        });
        if (ctrl) {
            controllers.push(ctrl);
        }
    });
};

export { createDemoPopinController, initDemoMenu };
